module.exports = __webpack_public_path__ + "img/9791158883843.b9341230.jpg";